var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.componentType,_vm._b({tag:"component",class:_vm.buttonClasses,attrs:{"type":_vm.isSubmit ? 'submit' : 'button',"relative":_vm.relative},on:{"click":function($event){return _vm.$emit('click', $event)}}},'component',_vm.links,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }